exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".mismatch-table table {\n  width: 100%;\n}\n.mismatch-table td {\n  padding: 0.4rem;\n}\n.mismatch-table__left {\n  text-align: left;\n}\n.mismatch-table__right {\n  text-align: right;\n  margin-left: 50px;\n}\n.mismatch-table #taxPercent {\n  width: 10rem;\n}\n@media (max-width: 480px) {\n  .mistmatch-table td {\n    font-size: 1.55rem;\n  }\n}\n", ""]);

// exports
